// this file is generated by update_shopify_store_data.py at 2026-11-03 20:14:15.269346
var courses = [
    {
        "course_id": "46300E20-04B7-E611-9821-005056B10F02",
        "course_version": 9,
        "name": "Creating Affirming Healthcare Environments for LGBTQIA+ Individuals",
        "course_type": 1,
        "author_information": "Cedar Interactive",
        "description": "Welcome to an introduction to creating affirming healthcare environments for our LGBTQIA+ individuals, families, and visitors! Providing high-quality healthcare means doing so for all individuals and their families, including LGBTQIA+ people.",
        "learning_objectives_html": "This course will review the following topics:\r\n<ul>\r\n    <li>Creating a Welcoming Healthcare Environment for&nbsp;LGBTQIA+ Individuals</li>\r\n    <li>What's in the Acronym?</li>\r\n    <li>Defining Gender</li>\r\n    <li>Defining Sexual Orientation</li>\r\n    <li>Self-Identification First</li>\r\n    <li>Gender Identity: More Terminology</li>\r\n    <li>Gender Affirmation</li>\r\n    <li>Pronouns are Important!</li>\r\n    <li>LGBTQIA+ Communities in the U.S.</li>\r\n    <li>How Many</li>\r\n    <li>Health Disparities</li>\r\n    <li>Health Factors for&nbsp;LGBTQIA+ Patients</li>\r\n    <li>LGBTQIA+ Health Outcomes</li>\r\n    <li>Doing Our Part</li>\r\n    <li>Affirming Our Patients, Their Families, and Our Colleagues</li>\r\n    <li>Daily Tips for Providing&nbsp;LGBTQIA+ Affirming Healthcare</li>\r\n    <li>Laws Around&nbsp;LGBTQIA+ Patient Care</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9C5A616-40D6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: Cedar Interactive",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF875D23-03B7-E611-9821-005056B10F02",
                "course_category_name": "Cedar Interactive",
                "is_system_course_category": null
            },
            {
                "course_category_id": "37A67743-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Interactions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E9471268-F2DC-E611-A37D-005056B17C80",
                "course_category_name": "Cedar-Interactive: Creating a Welcoming HealthCare Environment for LGBTQIA+ Patients",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                "course_category_name": "Cultural Awareness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CE392C4B-03B7-E611-9821-005056B10F02",
                "course_category_name": "Cedar_Interactive - Creating a Welcoming HealthCare Environment for LGBTQIA+ Patients",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];